module.exports = __webpack_public_path__ + "img/feat_stable.a3780e47.png";